import { useCallback, useState } from 'react';
import { InputDescription, InputTitle } from 'components/atoms/styleds';
import Input from 'components/atoms/Input';

import { ConfigBlock } from '../../styled';

const FormSetup = ({ data, onChange }) => {
  const items = [
    {
      id: 'table_reservation',
      title: 'Prenotazione tavoli',
    },
    {
      id: 'takeaway',
      title: 'Asporto',
    },
    {
      id: 'delivery',
      title: 'Delivery',
    },
  ];

  return (
    <ConfigBlock showBorder={true}>
      <div style={{ marginTop: 20 }}>
        <InputTitle>Configura il servizio di delivery</InputTitle>
        <InputDescription>
          Puoi impostare un minimo d’ordine per il servizio di delivery
          (facoltativo).
        </InputDescription>
        <Input
          name='min_order_cost_for_delivery'
          label='Valore in €'
          placeholder='00.00'
          value={data.min_order_cost_for_delivery}
          onChange={onChange}
        />
        <div style={{ marginTop: 40 }}>
          <InputDescription>
            Puoi impostare un minimo d’ordine per offrire la consegna gratuita
            (facoltativo).
          </InputDescription>
          <Input
            name='min_order_cost_for_free_delivery'
            label='Valore in €'
            placeholder='00.00'
            value={data.min_order_cost_for_free_delivery}
            onChange={onChange}
          />
        </div>
      </div>
    </ConfigBlock>
  );
};

export default FormSetup;
